<template>
  <div class="md:min-h-screen flex justify-center items-center flex-col">
    <TokenInvalid v-if="tab == -2"/>

    <div v-else-if="tab == 0" class="" style="border-radius: 8px;">
      <ReviewForm
          :guarantor="guarantor"
          :next="proceed"
          next_text="Fill Missing Fields"
      />
    </div>

    <div v-else-if="tab == 3" class="overflow-scroll" style="border-radius: 8px">
      <ReviewForm
          :guarantor="guarantor"
          :next="submitForm"
          :loading="isLoading"
          next_text="Submit Form"
      >
        <template #pre-header>
          <div
              @click="previous"
              class="cursor-pointer w-max ml-3"
          >
            <b-icon
                icon="arrow-left"
                size="is-small"
            />
          </div>
        </template>
      </ReviewForm>
    </div>

    <div v-else class="max-w-full sm:max-w-md mx-auto w-full max-sm:h-full relative">
      <div class="inset-y-0 right-0 flex flex-col justify-center items-center _h-full md:_h-5/6 md:my-3 min-h-screen w-full bg-white sm:rounded-lg">        
      	<LoanFormLoading v-if="tab == -1" />

        <div v-else-if="tab == 1" class="s-height h-full w-full relative">
          <div class="px-4 sm:px-10">
            <div class="flex justify-between items-center mt-5 mb-3 mr-3">
                <span>
                    <button
                        @click="previous"
                    >
                        <i class="ri-arrow-left-line text-gray-900" style="font-size: 1.7em"></i>
                    </button>
                </span>

                <img src="@/assets/images/sycamore_logo.svg" width="100"/>
            </div>

            <div class="text-center">
              <p class="text-lg font-bold text-black pb-2">Confirm information</p>
              <p class="pt-1 text-sm">
                <span class="font-medium">{{ guarantor.name.split(' ')[0] }}</span>,
                Please confirm that your details are correct. You have been requested by <b> {{ guarantor.customer_name }} </b> to be a guarantor for a <b>{{ guarantor.currency?.symbol ?? '₦' }}{{ guarantor.loan_amount.toLocaleString() }}</b>
              </p>

              <p class="pt-2 text-sm"> Some fields have been prefilled for you, but you need to <span class="text-primary font-medium underline">Edit</span> and/or <span class="text-primary font-medium underline">Update</span> the rest of the form. </p>
            </div>

            <div class="border rounded-lg p-4 mt-4">
              <h3 class="text-sm md:text-md font-medium pb-3 text-gray07">Guarantor Details</h3>
              <ul class="">
                <li class="flex justify-between text-xs pb-2 mb-2 border-b-2 text-gray-500">
                  <span class="text-black">Name</span>
                  <span>{{ guarantor?.customer_name }}</span>
                </li>

                <li class="flex justify-between text-xs pb-2 mb-2 border-b-2 text-gray-500">
                  <span class="text-black">Email</span>
                  <span>{{ guarantor?.customer_email }}</span>
                </li>

                <li class="flex justify-between text-xs pb-2 border-b-2 mb-2 text-gray-500">
                  <span class="text-black">Amount</span>
                  <span>{{ guarantor.currency?.symbol ?? '₦' }}{{ guarantor?.loan_amount.toLocaleString() }}</span>
                </li>

                <li class="flex justify-between text-xs pb-2 border-b-2 text-gray-500">
                  <span class="text-black">Address</span>
                  <span>{{ guarantor.customer_address }}</span>
                </li>
              </ul>
            </div>

            <div class="mt-7 pb-10">
              <form @submit.prevent="openOTPTab" class="mt-7 pb-20 columns is-multiline">
                <div class="column is-12">
                  <div class="field">
                    <label class="">Name</label>
                    <div class="control">
                      <input class="input" required v-model="guarantor.name" type="text">
                    </div>
                  </div>
                </div>

                <div class="column is-12">
                  <div class="field">
                    <label class="">Phone number</label>
                    <div class="control">
                      <input
                          class="input"
                          v-model="guarantor.phone"
                          type="text"
                          maxlength="11"
                          required
                          placeholder="08111111111"
                      >
                    </div>
                  </div>
                </div>

                <div class="column is-12">
                  <div class="field">
                    <label class="">Email</label>
                    <div class="control">
                      <input disabled class="input" v-model="guarantor.email" type="email" placeholder="example@mail.com">
                    </div>
                  </div>
                </div>

                <div class="column is-12">
                  <div class="field">
                    <label class="">Home Address</label>
                    <div class="control">
                      <textarea required class="input" v-model="guarantor.address" type="text" placeholder="53b Oduduwa way">
                      </textarea>
                    </div>
                  </div>
                </div>

                <div class="column is-12">
                  <div class="field">
                    <label class="">Business Address</label>
                    <div class="control">
		                <textarea class="input" required v-model="guarantor.business_address" type="text" placeholder="53b Oduduwa way">
		                </textarea>
                    </div>
                  </div>
                </div>

                <div class="column is-12">
                  <div class="field">
                    <label class="">Occupation</label>
                    <div class="control">
                      <b-autocomplete
                          v-model="guarantor.occupation"
                          placeholder="Type occupation."
                          :open-on-focus="true"
                          required
                          attached
                          readonly
                          @select="(option) => (guarantor.occupation = option)"
                          :clearable="true"
                          :keep-first="true"
                          :data="filteredOccupations"
                      />
                    </div>
                  </div>
                </div>

                <div v-if="guarantor.occupation == 'Others'" class="column is-12">
                  <div class="field mt-5">
                    <label class="">Enter Occupation</label>
                    <div class="control">
                      <input class="input" required v-model="guarantor.occupation_others" type="text">
                    </div>
                  </div>
                </div>


                <div class="column is-12">
                  <div class="field">
                    <label class="">BVN</label>
                    <div class="control">
	                    <input
	                      	class="input"
	                       	required
	                        v-model="guarantor.bvn"
	                        :min-length="9"
	                        :max-length="9"
	                    >
                    </div>
                  </div>
                </div>

                <div :class="['column field', guarantor.nin_verification_type == '' ? 'is-12' : 'is-6']">
                  <label class="">BVN Verification</label>
                  <div class="control">
                    <div class="select w-full">
                      <select
                          class="w-full"
                          required
                          v-model="guarantor.nin_verification_type"
                          name="nin_verification_type"
                      >
                        <option value="dob"> Date Of Birth</option>
                        <option value="phone"> Phone Number</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div v-if="guarantor.nin_verification_type == 'phone'" class="column is-6 field">
                  <label class="">Phone Number</label>
                  <div class="control">
                    <input
                        class="input"
                        required
                        v-model="guarantor.nin_phone"
                        name="nin_phone"
                        maxLength="15"
                        minLength="11"
                        type="tel"
                    />
                  </div>
                </div>

                <div v-if="guarantor.nin_verification_type == 'dob'" class="column is-6 field">
                  <label class="">Date of Birth</label>
                  <div class="control">
                    <input
                        class=""
                        required
                        v-model="guarantor.nin_dob"
                        name="dob"
                        type="date"
                    />
                  </div>
                </div>

                <div class="column is-12 absolute bottom-5 left-0 w-full px-5 sm:px-9">
                  <button
                      type="submit"
                      class="button is-fullwidth is-primary"
                      :class="isLoading ? 'is-loading' : ''"
                      :disabled="isLoading"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else-if="tab == 2" class="s-height md:min-h-5/6 w-full">
            <div class="grid grid-cols-3 mb-2 px-5 pt-5">
              <div class="my-auto">
                <div
                    @click="previous"
                    class="cursor-pointer w-max"
                >
                  <b-icon
                      icon="arrow-left"
                      size="is-small"
                  />
                </div>
              </div>
              <div class="mx-auto flex justify-center items-center gap-3 mb-4">
                <img src="@/assets/images/sycamore_logo.svg" width="100"/>
              </div>
              <div></div>
            </div>

            <div class="card-content">
              <form action="POST" accept-charset="UTF-8" class="flex flex-col gap-6">
                <div>
                  <div class="text-center">
                    <p class="text-md font-semibold text-gray-900 pb-1">Upload Signature</p>
                  </div>

                  <div class="w-full mt-1">
                    <b-field>
	                    <b-upload
	                      	@input="handleFileChange($event, 'signature')"
	                       	accept=".jpg, .jpeg, .png, .pdf"
	                        class="upload-container"
	                        :class="guarantor.signature !== null? 'uploaded' : ''"
	                        expanded
	                    >
	                        <a class="upload-button w-full h-full flex justify-center items-center">
	                            <span
									v-if="!guarantor.signature"
	                                class="dds text-gray-600 flex justify-center items-center"
								>
	                                <i class="ri-2x ri-upload-cloud-2-line font-light"></i>
	                                <span class="pl-2 font-medium">Click to upload</span>
	                            </span>
			                    <span v-else class="font-medium" style="color:#00a746">{{ guarantor.signature.name }}</span>
	                        </a>
	                    </b-upload>
                    </b-field>
                  </div>
                </div>

                <div v-for="(key, document) in guarantor.documents" :key="key">
                  <div class="text-center">
                    <p class="text-md font-semibold text-gray-900 pb-1">Upload {{ document.replaceAll('_', ' ') }}</p>
                  </div>

                  <div class="w-full mt-1">
                    <b-field>
	                    <b-upload
	                      	@input="handleFileChange($event, document)"
	                       	accept=".jpg, .jpeg, .png, .pdf"
	                        class="upload-container"
	                        :class="guarantor.documents[document] !== null? 'uploaded' : ''"
	                        expanded
	                    >
	                        <a class="upload-button w-full h-full flex justify-center items-center">
	                            <span
	                            	v-if="!guarantor.documents[document]"
	                                class="dds text-gray-600 flex justify-center items-center"
	                            >
	                                <i class="ri-2x ri-upload-cloud-2-line font-light"></i>
	                                <span class="pl-2 font-medium">Click to upload</span>
	                            </span>
		                        <span
		                          	v-else
		                           	class="font-medium"
		                            style="color:#00a746"
		                        >
		                        	{{ guarantor.documents[document].name }}
		                        </span>
	                        </a>
	                    </b-upload>
                    </b-field>
                  </div>
                </div>

                <div class="flex">
                  <div class="buttons ml-auto">
                    <b-button
                        native-type="button"
                        @click="gotoReview"
                        :loading="isLoading"
                        class="button is-primary text-sm md:w-48"
                        :disabled="isLoading ? true : false"
                    >
                      Review Form
                    </b-button>
                  </div>
                </div>
              </form>
            </div>
        </div>

        <div v-else-if="tab == 4" class="s-height w-full">
          <LoanFormSubmitSuccess/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {verifyToken, verifyOTP} from "@/api/auth";
import {fillGuarantorForm} from "@/api/loan";
import OTPBoxes from '@/components/otp/boxes'
import Ripple from '@/components/Ripple';
import ReviewForm from "@/components/loan/guarantorReviewForm";
import LoanFormSubmitSuccess from "@/components/loan/formSubmitSuccess";
import LoanFormLoading from "@/components/loan/loading";
import TokenInvalid from "@/components/TokenInvalid.vue";
import {validator} from "@/plugins/validator";

export default {
  components: {
    TokenInvalid,
    OTPBoxes,
    Ripple,
    ReviewForm,
    LoanFormSubmitSuccess,
    LoanFormLoading
  },
  data() {
    return {
      otp: '',
      tab: -1,
      file: null,
      isLoading: false,
      action: null,
      occupationFilter: "",
      occupations: [
        "Accountant",
        "Auditor",
        "Banker",
        "Consultant",
        "Lawyer",
        "Civil Servant",
        "Human Resource Manager",
        "Project Manager",
        "IT Specialist",
        "Software Developer",
        "Data Analyst",
        "Product Manager",
        "Architect",
        "Engineer",
        "Doctor",
        "Nurse",
        "Pharmacist",
        "Researcher",
        "Teacher",
        "Lecturer",
        "Professor",
        "Electrician",
        "Plumber",
        "Welder",
        "Mechanic",
        "Technician",
        "Builder / Mason",
        "Professional Driver",
        "Tailor / Fashion Designer",
        "Carpenter",
        "Hairdresser",
        "Makeup Artist",
        "Photographer",
        "Graphic Designer",
        "Business Owner",
        "Entrepreneur",
        "Trader / Market Seller",
        "Real Estate Agent",
        "Event Planner",
        "Caterer",
        "Farmer",
        "Transport Business Owner",
        "School Principal",
        "Government Worker",
        "Public Servant",
        "Journalist",
        "Writer",
        "Actor",
        "Musician",
        "Radio/TV Presenter",
        "Videographer",
        "Others",
      ],
      guarantor: {
        signature: null,
        email: "",
        phone: "",
        name: "",
        address: "",
        occupation: "",
        occupation_others: "",
        business_address: "",
        documents: {},

        bvn: "",
        nin_phone: "",
        nin_dob: "",
        nin_verification_type: "",

        "loan_id": "",
        "loan_amount": 0,
        "customer_email": "",
        "customer_name": "",
        "customer_address": "",

        "date": "",
      },
    }
  },

  computed: {
    guarantorOccupation() {
      return this.guarantor.occupation_others || this.guarantor.occupation;
    },
    filteredOccupations() {
      return this.occupations
          .filter(occupation => occupation.toLowerCase().includes(this.occupationFilter))
    }
  },

  methods: {
    handleFileChange(value, key) {
      const canUpload = this.$dataHandler.onFileChange(value);
      if (canUpload) {
        if (key == 'signature') {
          this.guarantor.signature = value;
        } else {
          this.guarantor.documents[key] = value;
        }
      } else {
	    this.$buefy.notification.open({
	        message: "Please upload a valid file. File must be either (png, jpg, jpeg, pdf)",
	        duration: 7000,
	        progressBar: true,
	        type: 'is-danger',
	        pauseOnHover: true
	    })
        this.file = null
      }
    },
    gotoReview() {
    	if (!this.guarantor.signature || !Object.values(this.guarantor.documents).every(doc => !!doc)) {
		      this.$buefy.notification.open({
		          message: "Please upload a valid file. File must be either (png, jpg, jpeg, pdf)",
		          duration: 7000,
		          progressBar: true,
		          type: 'is-danger',
		          pauseOnHover: true
		      })
      
			return;
     	}
     
      	this.proceed();
    },
    async openOTPTab() {
     	if (!this.validate()) return;
        this.proceed();
		return;
    },
    validate() {
    	return validator([
			{ type: 'required|string', name: "Email", data: this.guarantor.email, message: "Please enter a valid email" },
			{ type: 'required|phone', name: "Phone", data: this.guarantor.phone, message: "Please enter a valid Phone" },
			{ type: 'required|string|fullname', name: "Name", data: this.guarantor.name, message: "Please enter a valid Name" },
			{ type: 'required|string', name: "Occupation", data: this.guarantorOccupation, message: "Please enter a valid Occupation" },
			{ type: 'required|string|alphanumeric|hasAlphabet', name: "Address", data: this.guarantor.address, message: "Home Address can only contain alphanumeric characters and these symbols in bracket (,.)" },
			{ type: 'required|string|alphanumeric|hasAlphabet', name: "Business Address", data: this.guarantor.business_address, message: "Business Address can only contain alphanumeric characters and these symbols in bracket (,.)" },
			{ type: 'required|number|maxLength|minLength', name: "Bvn", data: this.guarantor.bvn, maxLength: 11, minLength: 11, message: 'Invalid BVN. Please enter a valid 11-digit BVN”' },
			{ type: 'required|number', name: "Loan id", data: this.guarantor.loan_id },
		]);
    },
    async submitForm() {
    	if (!this.validate()) return;
		
      const form = new FormData();
      const payload = {
        "email": this.guarantor.email,
        "phone": this.guarantor.phone,
        "name": this.guarantor.name,
        "address": this.guarantor.address,
        "occupation": this.guarantorOccupation,
        "business_address": this.guarantor.business_address,
        "bvn": this.guarantor.bvn,
        "loan_id": this.guarantor.loan_id,
      }

      if (this.guarantor.nin_dob)
        payload.dob = this.guarantor.nin_dob;

      if (this.guarantor.nin_phone)
        payload.phone = this.guarantor.nin_phone;

      for (let item in payload) {
        form.append(item, payload[item]);
      }
      
      for (let doc in this.guarantor.documents) {
        form.append(
            doc == "cac_document" ? "cac" : doc,
            this.guarantor.documents[doc]
        );
      }

      try {
        this.isLoading = true;
        await fillGuarantorForm(form);
        this.proceed();
      } catch (e) {
        this.$buefy.notification.open({
            message: e.response.data.message ?? e.message,
            duration: 7000,
            progressBar: true,
            type: 'is-danger',
            pauseOnHover: true
        })
      } finally {
        this.isLoading = false;
      }
    },
    proceed() {
      this.tab = this.tab + 1;
    },
    previous() {
      this.tab -= 1;
    },
    filterOccupations(text) {
      if (text == null) {
        return;
      }
      this.occupationFilter = text;
    },
    async fetchUserDetails() {
      const {token} = this.$route.query;

      this.isLoading = true;
      try {
        let response = await verifyToken({userToken: token});
        this.guarantor = {
          ...this.guarantor,
          ...response.data.data,
          occupation: response.data.data.occupation,
          documents: response.data.data.document_to_upload
              ?.split(",")
              .reduce((acc, curr) => ({
                ...acc,
                [curr]: null
              }), {}) ?? {},
        }

        this.tab = 0;
      } catch (e) {
        this.tab = -2;
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    this.fetchUserDetails();
  }
}
</script>


<style lang="scss" scoped>
.upload-container {
  height: 150px;
  width: 100%;
  border-radius: 7px;
  padding: 8px;
  aspect-ratio: 1;
  position: relative;
  clip-path: inset(0 round 30px 0 30px 0);
}

.upload-container::before, .uploaded::before {
  content: '';
  position: absolute;
  right: -7px;
  top: -7px;
  left: -7px;
  bottom: -7px;
  border: 8px dashed #bcbaba;
  border-radius: 37px 0 37px 0;
  box-sizing: border-box;
  transition: background .2s ease-in-out, border .2s ease-in-out;
}

.upload-container:hover::before, .uploaded::before {
  border: 8px dashed #00bf4e;
}

.upload-button {
  position: relative;
  z-index: 2;
  background-color: #55555511;
  transition: background .2s ease-in-out, border .2s ease-in-out;
  border-radius: 28px 0 28px 0;
}

.upload-button:hover, .uploaded .upload-button {
  background-color: #d6eee1;
}

.upload-button:hover .dds {
  color: #00a746;
}

.s-height {
  // height: 100vh;
  font-family: 'Poppins';
}

.s-width {
  width: 100vw;
}

label {
  font-size: 13px;
  font-weight: 500;
  display: block;
  padding-bottom: 5px;
  color: #484848;
}

.button {
  height: 45px !important;
  border-width: 0.5px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.input {
  height: 40px !important;
  font-size: 12px !important;
  color: #001800 !important;
  padding-left: 19px 1 !important;
  box-shadow: none !important
}

.double-box-shadow {
  box-shadow: rgba(224, 224, 224, 1) 3px 3px, rgba(245, 245, 245, 1) 7px 7px;
}
</style>
